/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of Angular Flex-Layout.
 */
export * from '@ngbracket/ngx-layout/core';
export * from '@ngbracket/ngx-layout/extended';
export * from '@ngbracket/ngx-layout/flex';
export * from '@ngbracket/ngx-layout/grid';
// Flex-Layout Module
export * from './module';
export * from './version';
